import React from 'react';
import { AppGridLayout, AppTableSearch, AppTable, AppRow, AppButton } from 'qcc';
import { AppAction, AppGridBar, AppSearchItem } from 'qcc';
import api, { PosMerchant } from "api";
import EditForm from "./EditForm";
import { Icon } from 'antd';
import DeviceIndex from './DeviceIndex';
import SetManagerPassword from './SetManagerPassword';
import SetManager from './SetManager';

const divCss = { color: 'blue', cursor: 'pointer' }

const iconCss = { marginLeft: '10' }

export default class extends React.Component {
  state = {}

  add = async () => {
    let { projectId } = this.refSearch.current.state.data;
    if (projectId) {
      let formData = { id: 0, business_name: '广州银商', project_id: projectId };
      let title = '新增POS商户';
      let width = 900;
      let height = 380;
      let bankOptions = await this.getBankOptions(projectId);
      let editForm = <EditForm mode={1} formData={formData} afterSave={this.afterSave} extraData={{ bankOptions }} />
      AppAction.openDialog(editForm, {
        title, height, width
      });
    }

  }

  edit = async (data?: any) => {
    let title = '编辑POS商户';
    let width = 900;
    let height = 380;
    let { project_id } = data;
    let bankOptions = await this.getBankOptions(project_id);
    let editForm = <EditForm mode={2} formData={{ ...data }} afterSave={this.afterSave} extraData={{ bankOptions }} />
    AppAction.openDialog(editForm, { title, height, width });
  }

  getBankOptions = async (projectId?: number) => {
    return await api.posmerchant.getProjectBankOptions({ projectId });
  }

  delete = async (data?: any) => {
    if (await AppAction.deleteConfirm('您确定要删除该记录吗？')) {
      await api.posmerchant.delete({ id: data.id });
      AppAction.successMsg('操作成功！');
      this.afterSave();
    }
  }

  openDeviceIndex = (data?: any) => {
    let title = `绑定POS设备(${data.merchant_name})`
    let width = 920;
    let indexForm = <DeviceIndex posMerchantId={data.id} />
    AppAction.openDrawer(indexForm, {
      width, title, onClose: () => {
        this.refGrid.current && this.refGrid.current.state.refTable.fetch();
      }
    });
  }

  setManagerPassword = (data?: any) => {
    AppAction.openDialog(<SetManager mode={2} formData={{ ...data }} />, { title: '设置主管账号', width: 500, height: 300 })
  }

  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }

  refGrid = React.createRef<AppGridLayout>();

  refSearch = React.createRef<AppTableSearch>();

  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.SearchArea>
          <AppTableSearch ref={this.refSearch}>
            <AppTableSearch.Common>
              <AppSearchItem.ProjectTree keyName='projectId' projectTreeScene={6601} field='project_id' lable='项目：' />
              <AppSearchItem.SearchInput placeholder='请录入名称或商户号'
                keyName='common' field='merchant_name,merchant_code' />
            </AppTableSearch.Common>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Right>
              <AppRow style={{ float: 'right', marginRight: 20 }}>
                <AppButton label='新增' actionCode="66201201" type='primary' action={this.add} />
              </AppRow>
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable paging
            leftFixIndex={1}
            rightFixIndex={8}
            sqlId='sql.pos.merchantGrid'
            onBeforeApi={(data: any) => { return data.projectId !== undefined }}  >
            <AppTable.ColIndex />
            <AppTable.Col title='POS商户名称' field='merchant_name' width={320} />
            <AppTable.Col title='POS商户号(银行卡)' field='merchant_code' width={200} />
            <AppTable.Col title='POS商户号(扫码)' field='merchant_code_scan' width={200} />
            <AppTable.Col title='收单机构' field='business_name' width={150} />
            <AppTable.Col title='银行名称' field='bank_name' width={400} />
            <AppTable.Col title='银行账号' field='bank_number' width={200} />
            <AppTable.Col title='POS设备' align='center' render={(data: any) => {
              let count = data.device_count;
              return <div style={divCss} onClick={() => this.openDeviceIndex(data)}>{count}<Icon style={iconCss} type='edit' /></div>

            }} width={100} />
            <AppTable.ColAction width={200} render={(data: any, dataIndex: number) => {
              return (<AppRow itemSplit={10} style={{ float: 'right', marginRight: 10 }}>
                <AppButton type='link' label='设置主管账号' actionCode="66201204" action={() => this.setManagerPassword(data)} />
                <AppButton type='link' label='编辑' actionCode="66201202" action={() => this.edit(data)} />
                <AppButton type='link' label='删除' actionCode="66201203" action={() => this.delete(data)} />
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/merchant/index.tsx